export default __webpack_public_path__ + "ba7acaece1db35c4dac621d5d36f7dbe.jpg";